import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslatePipe} from '@brunata-angular/util';
import {InputSelectOptionGroupComponent} from '@brunata-angular/ui';
import {
    exportDateFormatLabels,
    exportDateFormats,
    ExportFileFormat,
    ExportFileFormatForm,
    exportTimestampFormatOptions,
    literalLabelOptions,
} from '../../shared/models/export-file-format.model';
import {exportedTimestampExample} from '../../file-preview/exported-value.model';
import {SettingsRowComponent} from './settings-row.component';

@Component({
    selector: 'app-dates-tab',
    standalone: true,
    imports: [
        ReactiveFormsModule,
        TranslatePipe,
        InputSelectOptionGroupComponent,
        SettingsRowComponent,
    ],
    template: `
        <app-settings-row hintKey="customizedexports_export_fileformat_date_format_hint">
            <app-input-select-option-group
                sortOrder="original"
                [labelCols]="5"
                [formControl]="form().controls.dateFormat"
                [data]="dateFormatOptions"
                [label]="
                    'customizedexports_export_fileformat_date_format_label'
                        | translate: 'online' : 'export'
                " />
        </app-settings-row>

        @if (carriesTimestamps()) {
            <app-settings-row hintKey="customizedexports_export_fileformat_timestamp_format_hint">
                <app-input-select-option-group
                    sortOrder="original"
                    [labelCols]="5"
                    [formControl]="form().controls.timestampFormat"
                    [data]="timestampFormatOptions()"
                    [label]="
                        'customizedexports_export_fileformat_timestamp_format_label'
                            | translate: 'online' : 'export'
                    " />
                <code hint-extra class="d-block">{{ timestampExample() }}</code>
            </app-settings-row>
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatesTabComponent {
    readonly form = input.required<ExportFileFormatForm>();
    readonly settings = input.required<ExportFileFormat>();
    readonly carriesTimestamps = input.required<boolean>();

    protected readonly dateFormatOptions = literalLabelOptions(
        exportDateFormats,
        exportDateFormatLabels,
    );

    protected readonly timestampFormatOptions = computed(() =>
        exportTimestampFormatOptions(this.settings().dateFormat),
    );

    protected readonly timestampExample = computed(() => exportedTimestampExample(this.settings()));
}
